import {
  type LngLat,
  type MapLocationRequest,
  Button,
  FullscreenPanel,
  FullscreenPanelBody,
} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {useBinaryState} from '@logistics-frontend/hooks'
import {memo, useMemo, useState} from 'react'

import {type AddressPin} from '../../../../../../../../api/address'
import {MAP_ANIMATION_DURATION_IN_MS} from '../../../../../../../../utils/constants'
import {useConfigContext} from '../../../../../../../../utils/contexts/ConfigContext'
import {AddressInfo} from '../AddressInfo/AddressInfo'
import {Map} from '../Map/Map'
import * as styles from './ButtonWithMapModal.classes'

/** Пропсы компонента ButtonWithMapModal */
type ButtonWithMapModalProps = {
  /** Является ли текущий выбираемый адрес - точкой "Откуда" */
  isSource: boolean
  /** Коллбэк на сохранение выбранного адреса */
  onSave: (addressPin: AddressPin) => void
}

/**
 * Компонент с кнопкой, открывающей модалку с картой для выбора адреса.
 */
export const ButtonWithMapModal = memo<ButtonWithMapModalProps>(function ButtonWithMapModal({isSource, onSave}) {
  const i18n = useI18n()

  const {location: currentUserLocation} = useConfigContext()

  const [mapCoordinates, setMapCoordinates] = useState<LngLat>(currentUserLocation)

  const [isModalOpened, openModal, closeModal] = useBinaryState(false)

  const initialMapLocation = useMemo<MapLocationRequest>(
    () => ({
      bounds: [currentUserLocation, currentUserLocation],
      duration: MAP_ANIMATION_DURATION_IN_MS,
    }),
    [currentUserLocation],
  )

  return (
    <>
      <div className={styles.openButtonContainer}>
        <Button onPress={openModal} shape="circle" size="xs" variant="default">
          {i18n('bdui.address.map.open_button', 'На карте')}
        </Button>
      </div>

      <FullscreenPanel anchor="bottom" opened={isModalOpened}>
        <FullscreenPanelBody>
          <Map initialLocation={initialMapLocation} onGoBack={closeModal} onLocationChange={setMapCoordinates} />
          <AddressInfo coordinates={mapCoordinates} isSource={isSource} onClose={closeModal} onSave={onSave} />
        </FullscreenPanelBody>
      </FullscreenPanel>
    </>
  )
})
